<div class="alert-modal-container">
    <p-dialog [(visible)]="isAlertModalVisible" [modal]="true" [style]="{ width: '398px', height: '347px' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
        <!-- <ng-template pTemplate="header">
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class="font-bold white-space-nowrap">Amy Elsner</span>
            </div>
        </ng-template> -->
        <h3 class="alert-text">
            Are you sure you want to delete ?
        </h3>
        <p class="sub-para">
            This action cannot be undone. Please double-check your decision before proceeding.
        </p>
        <ng-template pTemplate="footer">
            <p-button class="cancel-btn" (click)="cancel()" label="Cancel" pAutoFocus [autofocus]="true"></p-button>
            <p-button class="delete-btn" (click)="deleteEvent('delete')" label="Delete" pAutoFocus [autofocus]="true"></p-button>
        </ng-template>
    </p-dialog>
</div>
